import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { NavigationBar } from './NavigationBar';
import { useCaptureUTMParams } from '../utils/attribution_tracking';

/*
 * Types.
 */

const StyledOutletDiv = styled.div``;

const PageContainer = styled.div`
  background-color: white;
`;

/*
 * Component.
 */

export const GuestLayout: FC = () => {
  useCaptureUTMParams();
  return (
    <PageContainer>
      <NavigationBar search />
      <StyledOutletDiv>
        <Outlet />
      </StyledOutletDiv>
    </PageContainer>
  );
};
